import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import { bindActionCreators } from 'redux';

import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import beTimeOffAllowances from 'actions/timeoff/beTimeOffAllowances.action';
import beTimeOffCategories from 'actions/timeoff/beTimeOffCategories.action';
import beTimeOffReport from 'actions/timeoff/beTimeOffReport.action';
import Button from 'components/form/Button.component';
import Card from 'components/generic/Card.component';
import TimeOffCategories from 'components/hr/categories/TimeOffCategories.component';
import StaffTimeOffAllowances from 'components/hr/timeOffStaff/StaffTimeOffAllowances.component';
import LINK from 'constants/link.const';
import USER_ROLE from 'constants/role';
import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCalendarMode, selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';
import selectSupportedSalons from 'selectors/selectSupportedSalons';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import linkTo from 'utils/links/linkTo.util';
import logger from 'utils/logger.util';
import checkSupportSalon from 'utils/salons/checkSupportSalon';

import CN from './TimeOffSettingsLayout.module.scss';

const L = logger('TimeOffSettingsLayout');

const TimeOffSettingsLayout = ({ salonId, beTimeOffCategories, beTimeOffReport, beTimeOffAllowances, fetchStylistsBySalon, calendarMode, userRole, supportSalons }) => {
  const { t } = useTranslation();

  useEffect(() => {
    L.unignore('useEffect()', 'fetchStylistsBySalon:', fetchStylistsBySalon(salonId));
    L.unignore('useEffect()', 'beTimeOffCategories:', beTimeOffCategories({ salonId }));
    L.unignore('useEffect()', 'beTimeOffReport:', beTimeOffReport({ salonId }));
    L.unignore('useEffect()', 'beTimeOffAllowances:', beTimeOffAllowances({ salonId }));
  }, [beTimeOffAllowances, beTimeOffCategories, beTimeOffReport, fetchStylistsBySalon, salonId]);

  const isSupport = checkSupportSalon({ salons: supportSalons, salonId });
  const linkReports = linkTo({ pattern: LINK.slnStaffReportsTimeoff, params: { salonId } });

  return (
    <div className={cn(CN.layout, CN[calendarMode])}>
      <div data-bem="TimeOffSettings" className={cn(CN.component, CN[calendarMode])}>
        <div className={CN.flex}>
          <h1 className={CN.title}>{t('humanResources.timeOffSettings.section1title')}</h1>
          <div className={CN.linkContainer}>
            <NavLink to={linkReports}>
              <Button variant="primaryForce" onClick={alwaysNoop}>
                <span className={CN.buttonSpace}>{t('humanResources.timeOffSettings.viewTimeOffReportButton')}</span>
              </Button>
            </NavLink>
          </div>
        </div>

        <Card withShadow>
          <TimeOffCategories />
        </Card>
      </div>

      {(userRole === USER_ROLE.manager || isSupport) && (
        <div data-bem="TimeOffSettings__Staff" className={cn(CN.component, CN[calendarMode])}>
          <h1 className={CN.title}>{t('humanResources.timeOffSettings.section2title')}</h1>
          <Card withShadow>
            <StaffTimeOffAllowances />
          </Card>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  salonId: selectCurrentSalonId(state),
  calendarMode: selectCurrentSalonCalendarMode(state),
  userRole: selectEffectiveUserRole(state),
  supportSalons: selectSupportedSalons(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ beTimeOffCategories, beTimeOffReport, beTimeOffAllowances, fetchStylistsBySalon }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TimeOffSettingsLayout);
